export class Projectpendingjoiner {
    date_showed_interest:string;
    fullname:string;
    im?:string;
    email?:string;
    phone?:string;
    personId:string;
    projectId:string;
    projectrole:string;
}